import { Title } from '@angular/platform-browser';
import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class AppTitle {
	dashboardTitle: string;
	dashboardNav: string;
	title: Title;
	breadcrumbs: Breadcrumb[];
	useHashLocation: boolean;
	titleEvent = new EventEmitter();

	constructor() {
		this.title = new Title({});
		this.breadcrumbs = [];
		this.useHashLocation = true;

	}

	setTitles(t: any) {
		if (t.dashboard != null) {
			this.setDashboardTitle(t.dashboard);
		}
		if (t.title != null) {
			this.setTitle(t.title);
		}
		if (t.dashboardNav != null) {
			this.setDashboardNav(t.dashboardNav);
		}
	}

	setBreadcrumbs(bcs: Breadcrumb[]) {
		this.breadcrumbs = bcs;
		this.titleEvent.emit();
	}

	getBreadcrumbsPrint(): BreadcrumbPrint[] {
		let bcs = [];
		if (this.useHashLocation) {
			for (let b of this.breadcrumbs) {
				let nb = new BreadcrumbPrint();
				nb.link = '#' + b.link;
				nb.noLink = (b.link === '');
				nb.title = b.title;
				bcs.push(nb);
			}
		}
		return bcs;
	}

	setTitle(title: string) {
		this.title.setTitle(title);
	}

	getTitle() {
		this.title.getTitle();
	}

	setDashboardTitle(title: string) {
		this.dashboardTitle = title;
		this.titleEvent.emit();
	}

	getDashboardTitle() {
		return this.dashboardTitle;
	}

	setDashboardNav(title: string) {
		this.dashboardNav = title;
	}

	getDashboardNav() {
		return this.dashboardNav;
	}

	existsBreadcrumb(bc: Breadcrumb): boolean {
		for (let b of this.breadcrumbs) {
			if (b.title === bc.title) {
				return true;
			}
		}
		return false;
	}

}

export class Breadcrumb {
	title: string;
	link: string;
	constructor() {
		this.title = '';
		this.link = '';
	}
}

export class BreadcrumbPrint {
	title: string;
	link: string;
	noLink: boolean;
	constructor() {
		this.title = '';
		this.link = '';
		this.noLink = false;
	}
}
